module.exports = __webpack_public_path__ + "img/GEORGIA-V-CW.d87f1797.png";